import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { showAuthMessage, iniciaRecuperarSenhaFalha, recuperarSenhaSucesso, iniciaRecuperarSenhaSucesso } from "actions/RecuperarSenhaApp";
import requisicaoApiApp from 'util/ApiApp';
import md5 from 'md5';
import {
  INICIO_RECUPERAR_SENHA,
  RECUPERAR_SENHA,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_HIDE_LOADER,
} from 'constants/ActionTypes';
/*#################################################################################################################*/
/* --------------------------------------------- Requests do tipo GET ---------------------------------------------*/

const getBearerToken = async (idrecuperarsenha) =>
  await requisicaoApiApp.get(`/v1/autenticacao/recuperar-token/${idrecuperarsenha}`)
    .then(resposta => resposta)
    .catch(error => error);

const putTrocarSenha = async (body) =>
  await requisicaoApiApp.put(`/v1/autenticacao/alterar-senha`, {senha: md5(body.senha)}, {
      headers: {
        Authorization: `Bearer ${body.token}`
      }
    })
    .then(resposta => resposta)
    .catch(error => error);
/*#################################################################################################################*/
/* ------------------------------------------ Funções das Sagas ---------------------------------------------------*/

export function* recuperarSenhaApi() {
  yield takeEvery(RECUPERAR_SENHA, fnRecuperarSenha);
}

export function* iniciaRecuperacaoSenhaApp() {
yield takeEvery(INICIO_RECUPERAR_SENHA, fniniciaRecuperacaoSenha);

}

function* fnRecuperarSenha({ payload }) {
    try {
        const retorno = yield call(putTrocarSenha, payload);
        if (retorno.message) {
          yield put(showAuthMessage(JSON.stringify(retorno.message)));
        } else {
          yield put(recuperarSenhaSucesso(true));
        }
      } catch (error) {
        
        yield put(showAuthMessage(JSON.stringify(error)));
      }
}

function* fniniciaRecuperacaoSenha({ payload }) {
    try {
        
        const retorno = yield call(getBearerToken, payload);
        if (retorno.message) {
          yield put(iniciaRecuperarSenhaFalha());
        } else {
          yield put(iniciaRecuperarSenhaSucesso(retorno.data));
        }
      } catch (error) {    
        yield put(iniciaRecuperarSenhaFalha());
      }
}

export default function* rootSaga() {
  yield all([
    fork(recuperarSenhaApi),
    fork(iniciaRecuperacaoSenhaApp)
  ]);
}
